<template>
  <div class="route-bar">
    <div class="route-bar-breadcrumb">
      <ul>
        <li v-for="item in menu" :key="item" style="margin-left:2em">
          <button class="custom-button-route-breadcrumb" @click="goTo(item.to)">
            <div class="grid">
              <i :class="item.icon" style="font-size: 1.5rem; color: #03365F; margin-top:.5em;"/>
              <p :style="dynamicLabelStyle(item.to)">{{item.label}}</p>
            </div>
          </button>
        </li>
      </ul>
    </div>
    <ProgressBar v-if="loading" class="custom-progress-bar" mode="indeterminate" style="height:.20em"/>
    <div v-else style="height: .20em; width: 100%"></div>
  </div>
</template>

<script>
import {useAclStore} from "@/store/aclStore";
import {useLoadingStore} from "@/store/loadingStore";
import {useUserStore} from "@/store/userStore";

export default {
  beforeCreate() {
    this.aclStore = useAclStore();
    this.userStore = useUserStore()
    this.loadingStore = useLoadingStore()
  },
  beforeMount() { this.menu = this.appMenu },
  data(){ return { menu: {} } },
  computed: {
    user(){ return this.userStore.user},
    profile(){ return this.user.profile},
    loading() { return this.loadingStore.loading },
    breadcrumbMenu() { return this.aclStore.breadcrumbMenu },
    appMenu() { return this.$methods.isEmpty(this.aclStore.appMenu) ? [] : this.aclStore.appMenu[0].items },
  },
  methods: {
    goTo(path){ this.$router.push(path) },
    dynamicLabelStyle(path){
      return this.$route.fullPath === path ?
          'font-weight: bold; text-decoration-line: underline; margin-left:1em; margin-top:.9em; color:#03365F; cursor: pointer;' :
          'margin-left:1em; margin-top:.9em;  color:#6A7292; cursor: pointer;'},
  },
  watch:{
    profile(){ this.menu = this.appMenu },
    breadcrumbMenu(){ this.menu = this.breadcrumbMenu.items },
  }
}
</script>

<style scoped>
</style>